export const isLoading = state => {
  return Boolean(state.user.loading);
};

export const isError = state => {
  return Boolean(state.user.error);
};
